import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { useEffect, useRef, useState } from 'react';
import { RoleColumns } from '../../appconfig/DatatableSetting';
import { SkeletonbodyTemplate, Skeletonitems } from '../../appconfig/Settings';
import { getAllDetails } from '../../service/ProductService';
import { ROLE_LIST } from '../../config/ApiConstant';
import AppBreadcrumb from '../../components/CustomeBreadcrumb/AppBreadcrumb';
import { useNavigate } from 'react-router-dom';
import { getAction } from '../../appconfig/AppHelper';
import { PermissionTab } from './permissionTab';

export const RoleManagement = () => {
    document.title = 'Role Management | GSPC';

    //Filters and Loading
    const [globalFilter, setGlobalFilter] = useState<any>(null);
    const toast = useRef<any>(null);
    const [pageLoad, setPageLoad] = useState(false);

    //Role Data
    const [roleList, setRoleList] = useState<any>([]);
    const [viewRoleData, setViewRoleData] = useState<any>({});
    const [roleViewDialog, setRoleViewDialog] = useState(false);
    const [actions, setActions] = useState<any>([]);

    //Navigation
    const navigate = useNavigate();

    // use effect method
    useEffect(() => {
        getDataFromAPI();
        // setActions(getAction('Role Management'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get orders Data from API
    const getDataFromAPI = async () => {
        const response = await getAllDetails(ROLE_LIST);
        setPageLoad(false);
        // get response
        if (response) {
            if (response.length === 0) {
                setRoleList([]);
            } else {
                setRoleList(response);
            }
            setPageLoad(true);
        } else {
            setPageLoad(false);
            toast.current?.show({
                severity: 'error',
                summary: 'Alert',
                detail: 'Something went wrong, Please try again.'
            });
        }
    };

    // View Role
    const onRowSelection = (value: any) => {
        setRoleViewDialog(true);
        setViewRoleData(value);
    };

    const hideViewDialog = () => {
        setRoleViewDialog(false);
        setViewRoleData({});
    };

    // for column action
    const actionBodyTemplate = (rowData: any) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-primary" onClick={() => navigate('/app/permission/add-role', { state: { id: rowData.id } })} />
            </div>
        );
    };

    // right part of toolbar
    const leftToolbarTemplate = () => {
        return (
            <>
                <div>{!window.cn(actions) && 'add' in actions ? <Button label="Create Role" icon="pi pi-plus" className="p-button-primary ml-1" onClick={() => navigate('/app/permission/add-role')} /> : ''}</div>
            </>
        );
    };

    return (
        <>
           <PermissionTab mainTabLabel="RoleWise Menu Management" />
           <Toast ref={toast} />
           
            <div className="grid crud-demo mt-4">
                <div className="col-12">
                    <div className="card">
                      
                        <Toolbar left={leftToolbarTemplate}></Toolbar>
                        {pageLoad ? (
                            <>
                                <DataTable className="datatable-responsive" value={roleList} globalFilter={globalFilter} emptyMessage="No Role Found" showGridlines onSelectionChange={(e) => onRowSelection(e.value)} stripedRows>
                                    {RoleColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionBodyTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} filterPlaceholder={'Search by ' + col.header} filter />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {RoleColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* View Dialog Start*/}
            <Dialog visible={roleViewDialog} className="p-fluid" style={{ width: '850px' }} header="View Role" onHide={hideViewDialog} footer={true}>
                <div className="p-fluid formgrid grid">
                    <div className="field col f-col">
                        <label htmlFor="role">
                            <b>Role :</b> {!window.cn(viewRoleData) && !window.cn(viewRoleData?.role) ? viewRoleData?.role : ''}
                        </label>
                    </div>
                </div>
            </Dialog>
            {/* viewDialog start*/}
        </>
    );
};
